import { takeEvery, put, call } from "redux-saga/effects";

import {
  getCategoriesAPI,
  addCategoryAPI,
  getCategoryAPI,
  updateCategoryAPI,
  uploadCategoryIconAPI,
  deleteCategoryAPI,
  getCategoriesSelectListAPI,
} from "../../../helpers/backend.helper";
import {
  GET_CATEGORIES,
  ADD_CATEGORY,
  GET_CATEGORY,
  UPDATE_CATEGORY,
  DELETE_CATEGORY,
  UPLOAD_CATEGORY_ICON,
  GET_CATEGORIES_SELECT_LIST,
} from "./actionTypes";
import {
  addCategoryError,
  addCategorySuccess,
  deleteCategoryError,
  deleteCategorySuccess,
  getCategoryError,
  getCategoriesError,
  getCategoriesSuccess,
  getCategorySuccess,
  updateCategoryError,
  updateCategorySuccess,
  uploadCategoryIconSuccess,
  uploadCategoryIconError,
  getCategoriesSelectListSuccess,
  getCategoriesSelectListError,
} from "./actions";

function* getCategories({ payload: { request } }) {
  try {
    const response = yield call(getCategoriesAPI, request);
    if (response) {
      yield put(getCategoriesSuccess(response?.data));
    }
  } catch (error) {
    yield put(getCategoriesError(error));
  }
}

function* addCategory({ payload: { request } }) {
  try {
    console.log(request);
    const response = yield call(addCategoryAPI, request);
    if (response) {
      yield put(addCategorySuccess());
    }
  } catch (error) {
    yield put(addCategoryError(error));
  }
}

function* getCategory({ payload: { id } }) {
  try {
    const response = yield call(getCategoryAPI, id);
    if (response) {
      yield put(getCategorySuccess(response?.data));
    }
  } catch (error) {
    yield put(getCategoryError(error));
  }
}

function* updateCategory({ payload: { request } }) {
  try {
    const response = yield call(updateCategoryAPI, request);
    if (response) {
      yield put(updateCategorySuccess());
    }
  } catch (error) {
    yield put(updateCategoryError(error));
  }
}

function* deleteCategory({ payload: { id } }) {
  try {
    const response = yield call(deleteCategoryAPI, id);
    if (response) {
      yield put(deleteCategorySuccess());
    }
  } catch (error) {
    yield put(deleteCategoryError(error));
  }
}

function* uploadCategoryIcon({ payload: { icon } }) {
  try {
    const response = yield call(uploadCategoryIconAPI, icon);
    if (response) {
      yield put(uploadCategoryIconSuccess(response?.data));
    }
  } catch (error) {
    yield put(uploadCategoryIconError(error));
  }
}

function* getCategoriesSelectList() {
  try {
    const response = yield call(getCategoriesSelectListAPI);
    if (response) {
      yield put(getCategoriesSelectListSuccess(response?.data));
    }
  } catch (error) {
    yield put(getCategoriesSelectListError(error));
  }
}

function* categoriesSaga() {
  yield takeEvery(GET_CATEGORIES, getCategories);
  yield takeEvery(ADD_CATEGORY, addCategory);
  yield takeEvery(GET_CATEGORY, getCategory);
  yield takeEvery(UPDATE_CATEGORY, updateCategory);
  yield takeEvery(DELETE_CATEGORY, deleteCategory);
  yield takeEvery(UPLOAD_CATEGORY_ICON, uploadCategoryIcon);
  yield takeEvery(GET_CATEGORIES_SELECT_LIST, getCategoriesSelectList);
}

export default categoriesSaga;
